<!-- 路线页 -->
<template>
  <div class="route">
    <!-- 头部 -->
    <div class="top">
      <router-link to="/" class="topLeft">
        <div class="backIcon">
          <img src="./image/icon_back.svg" alt="" />
        </div>
        <div class="backText">返回</div>
      </router-link>
      <div class="topTitle">路线</div>
    </div>
    <!-- 内容 -->
    <div class="content">
      <router-link to="/routeDetail" class="contentList">
        <div class="listImg"></div>
        <div class="listDetail">
          <div class="detailName">
            路线名称路线名称路线名称路线名称路线名称路线名称
          </div>
          <div class="detailData">
            <div class="leftCon">
              <div class="leftIcon"></div>
              <div class="leftNum">12</div>
            </div>
            <div class="rightCon">
              <div class="rightIcon"></div>
              <div class="rightNum">5</div>
            </div>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>
<style lang="less">
.route {
  width: 100%;
  height: 100vh;
  position: relative;
  .top {
    width: 100%;
    height: 4.8rem;
    position: absolute;
    top: 0;
    padding: 1.3rem 1.8rem;
    border-bottom: 0.1rem solid #eee;
    display: flex;
    background: #fafafa;
    .topLeft {
      width: 5rem;
      height: 2.2rem;
      display: flex;
      align-items: center;
      float: left;
      .backIcon {
        width: 2rem;
        height: 2rem;
      }
      .backText {
        width: 2.8rem;
        height: 2rem;
        font-size: 1.4rem;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: CENTER;
        color: #333333;
        line-height: 2rem;
      }
    }
    .topTitle {
      width: 3.2rem;
      height: 2.2rem;
      font-size: 1.6rem;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      color: #333333;
      line-height: 2.2rem;
      letter-spacing: 0rem;
      position: absolute;
      left: 50%;
      margin-left: -1.6rem;
    }
  }
  .content {
    width: 100%;
    height: 100%;
    padding: 4.8rem 1.65rem 0;
    background: #fafafa;
    .contentList {
      width: 16.5rem;
      height: 21.6rem;
      margin: 1.2rem 0.3rem 0;
      display: inline-block;
      .listImg {
        width: 16.5rem;
        height: 13.2rem;
        border-radius: 0.8rem 0.8rem 0rem 0rem;
        background: aqua;
      }
      .listDetail {
        width: 100%;
        height: 8.4rem;
        padding: 0.8rem 0.8rem 1rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        background: #fff;
        .detailName {
          width: 100%;
          height: 4rem;
          font-size: 1.4rem;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          text-align: LEFT;
          color: #333333;
          line-height: 2rem;
          letter-spacing: 0rem;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
        .detailData {
          width: 60%;
          height: 2rem;
          display: flex;
          .leftCon {
            width: 50%;
            height: 2rem;
            display: flex;
            align-items: center;
            .leftIcon {
              width: 1.8rem;
              height: 1.8rem;
              background: url("./image/icon_location.svg") no-repeat;
              background-size: 100%;
            }
            .leftNum {
              height: 2rem;
              font-size: 1.4rem;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              text-align: LEFT;
              color: #666666;
              line-height: 2rem;
            }
          }
          .rightCon {
            width: 50%;
            height: 2rem;
            display: flex;
            align-items: center;
            .rightIcon {
              width: 1.8rem;
              height: 1.8rem;
              background: url("./image/icon_picture.svg") no-repeat;
              background-size: 100%;
            }
            .rightNum {
              height: 2rem;
              font-size: 1.4rem;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              text-align: LEFT;
              color: #666666;
              line-height: 2rem;
            }
          }
        }
      }
    }
  }
}
</style>